/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import eeacmsvoltoColumnsBlock from '@eeacms/volto-columns-block';
import reudnitzTheme from 'reudnitz-theme';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.9.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/opt/volto-reudnitz/packages/volto-slate/src","packageJson":"/opt/volto-reudnitz/packages/volto-slate/package.json","basePath":"/opt/volto-reudnitz/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"@eeacms/volto-columns-block","version":"9.0.4","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/volto-reudnitz/node_modules/.pnpm/@eeacms+volto-columns-block@9.0.4_react@18.2.0/node_modules/@eeacms/volto-columns-block/src","packageJson":"/opt/volto-reudnitz/node_modules/.pnpm/@eeacms+volto-columns-block@9.0.4_react@18.2.0/node_modules/@eeacms/volto-columns-block/package.json","basePath":"/opt/volto-reudnitz/node_modules/.pnpm/@eeacms+volto-columns-block@9.0.4_react@18.2.0/node_modules/@eeacms/volto-columns-block","tsConfigPaths":null,"addons":[]},{"name":"reudnitz-theme","version":"1.0.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/volto-reudnitz/packages/reudnitz-theme/src","packageJson":"/opt/volto-reudnitz/packages/reudnitz-theme/package.json","basePath":"/opt/volto-reudnitz/packages/reudnitz-theme","tsConfigPaths":null,"addons":[],"razzleExtender":"/opt/volto-reudnitz/packages/reudnitz-theme/razzle.extend.js"}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, eeacmsvoltoColumnsBlock, reudnitzTheme];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
